<template>
    <relatorio-page :titulo="`Relatório Previsão Orçamentária (${itens.tipo}) - ` + itens.ano" :cabecalhoCompleto="true" :exportarExcel="true" :paisagem="true" :fonteVariavel="true">
        
        <v-simple-table id="tabela" v-if="itens.planoContas.length > 1" dense>
            <tbody v-for="(planoConta, index) in itens.planoContas" :key="index">
                <tr>
                    <td>
                        <v-simple-table dense class="py-1 text-caption">
                            <template v-slot: default>
                                <thead class="fonte" style="background-color: #4A70A8">
                                    <tr>
                                        <th rowspan="3" class="text-left" style="font-size: 90% ; color: white"> {{ planoConta.planoConta }} </th>
                                        <th class="text-right" style="font-size: 90% ; color: white" v-for="(mes, index) in planoConta.meses" :key="index">
                                            <span>{{ mes.mesStr }}</span>
                                        </th>
                                        <th class="text-right" style="font-size: 90% ; color: white">
                                            <span>Total</span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="text-right" style="font-size: 90% ; color: white" v-for="(mes, index) in planoConta.meses" :key="index">
                                            <span>{{ mes.valorOrcado.toMoeda() }}</span>
                                        </th>
                                        <th class="text-right" style="font-size: 90% ; color: white">
                                            <span>{{ planoConta.valorOrcado.toMoeda() }}</span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="text-right" style="font-size: 90% ; color: white" v-for="(mes, index) in planoConta.meses" :key="index">
                                            <span>{{ mes.valorReal.toMoeda() }}</span>
                                        </th>
                                        <th class="text-right" style="font-size: 90% ; color: white">
                                            <span>{{ planoConta.valorReal.toMoeda() }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="fonte" v-for="(item, index) in planoConta.planoContaItens" :key="index" :style=" index == itens.length - 1 ? 'background-color: #4A70A8' : index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                                    <tr>
                                        <td rowspan="2" class="text-left"   :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' ">{{item.planoContaItem}}</td>
                                        <td class="text-right" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' " v-for="(mes, index) in item.meses" :key="index"> 
                                            <span style="color: #4A70A8; font-weight: bold;">{{ mes.valorOrcado ? mes.valorOrcado.toMoeda() : Number(0).toMoeda() }}</span>
                                        </td>
                                        <td class="text-right" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' "> 
                                            <span style="color: #4A70A8; font-weight: bold;">{{ item.valorOrcado ? item.valorOrcado.toMoeda() : Number(0).toMoeda() }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' " v-for="(mes, index) in item.meses" :key="index"> 
                                            <span>{{ mes.valorReal ? mes.valorReal.toMoeda() : Number(0).toMoeda() }}</span>
                                        </td>
                                        <td class="text-right" :style=" index == itens.length - 1 ? 'font-size: 100% ; color: white' : 'font-size: 100%' "> 
                                            <span>{{ item.valorReal ? item.valorReal.toMoeda() : Number(0).toMoeda() }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </td>
                </tr>
                <tr v-if="index == itens.planoContas.length -1">
                    <td>
                        <v-simple-table dense>
                            <thead class="fonte" style="background-color: #4A70A8">
                                <tr>
                                    <th></th>
                                    <th style="font-size: 100% !important; color: white !important;" v-for="(mes, index) in itens.meses" :key="index">
                                        <div style="display: flex; flex-direction: column; align-items: flex-end; justify-content: center;">
                                            <span>{{ mes.mesStr }}</span>
                                        </div>
                                    </th>
                                    <th style="font-size: 100% !important; color: white !important;">
                                        <div style="display: flex; flex-direction: column; align-items: flex-end; justify-content: center;">
                                            <span>Total</span>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="fonte">
                                <tr>
                                    <td class="text-left" style="font-size: 100% !important;">
                                        <span>Total Previsto</span>
                                    </td>
                                    <td class="text-right" v-for="(mes, index) in itens.meses" :key="index" style="font-size: 100% !important;">
                                        <span style="color: #4A70A8; font-weight: bold;">{{ mes.valorOrcado ? mes.valorOrcado.toMoeda() : Number(0).toMoeda() }}</span>
                                    </td>
                                    <td class="text-right" style="font-size: 100% !important;">
                                        <span style="color: #4A70A8; font-weight: bold;">{{ itens.valorOrcado ? itens.valorOrcado.toMoeda() : Number(0).toMoeda() }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-left" style="font-size: 100% !important;">
                                        <span>Total Real</span>
                                    </td>
                                    <td class="text-right" v-for="(mes, index) in itens.meses" :key="index" style="font-size: 100% !important;">
                                        <span>{{ mes.valorReal ? mes.valorReal.toMoeda() : Number(0).toMoeda() }}</span>
                                    </td>
                                    <td class="text-right" style="font-size: 100% !important;">
                                        <span>{{ itens.valorReal ? itens.valorReal.toMoeda() : Number(0).toMoeda() }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>

        <v-row v-else>
            <v-col cols="12">
                Nenhum Registro Encontrado
            </v-col>
        </v-row>
        
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </relatorio-page>
</template>

<script>
import OrcamentoService from '../../../core/services/financeiro/OrcamentoService';

export default {
    
    data: () => ({
        itens:{
            planoContas: []
        },
        filtro:{
            required: true
        },
        overlay: false
    }),
    props:{

    },
    mounted(){
        this.filtro.id = this.$route.params.id;
        this.Carregar();
    },
    methods:{
        Carregar(){
            const service = new OrcamentoService();
            this.overlay = true;
            service.Relatorio(this.filtro.id).then(
                res=>{
                    this.itens = res.data;
                },
                err=>{
                    this.$swal('Aviso', err.response.data, 'error')
                }
            ).finally(() => {
                this.overlay = false;
            })
        }
    }   

}
</script>

<style scoped>

.fonte{
    font-size: 70%;
}

thead > tr > th{
    height: 20px !important;    
}
</style>
